<template>
  <QmulusButton
    v-bind="buttonProps"
    :data-qa="`semantic-button-${variant}`"
  />
</template>

<script setup lang="ts">
import {
  computed,
} from 'vue';

import useLibraryI18n from '../../i18n/composable.ts';

import {
  IQmulusButtonBaseProps,
  TQmulusButtonPresentation,
  TQmulusButtonProps,
} from './qmulus-button.ts';
import QmulusButton from './qmulus-button.vue';
import {
  SEMANTIC_BUTTON_VARIANT_MAP,
  TSemanticButtonVariant,
} from './semantic-button.ts';

export interface ISemanticButtonProps extends Omit<IQmulusButtonBaseProps, 'label' | 'severity'> {
  variant: TSemanticButtonVariant,
  label?: string,
  presentation?: TQmulusButtonPresentation,
}

const props = defineProps<ISemanticButtonProps>();

const {
  t,
} = useLibraryI18n('components/button/semantic-button');

const buttonProps = computed<TQmulusButtonProps>(() => {
  const {
    variant,
    label,
    presentation,
    ...sharedProps
  } = props;
  const rule = SEMANTIC_BUTTON_VARIANT_MAP[variant];
  const presentedAs = presentation ?? rule.presentation;
  const labelOfVariant = label || t(variant);

  if (presentedAs === 'labeled') {
    return {
      ...sharedProps,
      label: labelOfVariant,
      severity: rule.severity,
      presentation: presentedAs,
      icon: rule.isIconHiddenWhenLabeled ? undefined : rule.icon,
    };
  }
  return {
    ...sharedProps,
    label: labelOfVariant,
    severity: rule.severity,
    presentation: presentedAs,
    icon: rule.icon,
  };
});
</script>
